import SkipIntro from './SkipIntro';
import WatchFromStart from './WatchFromStart';
import NextEpisodeButton from './NextEpisode';
import UsePlayerProps from '../../../Store/usePlayerProps';
import { ActionBarContainer, ActionBarFlexWrapper } from '../../Player/styles';
import { useEffect, useState } from 'react';
import AdCounter from './AdCounter';

const ActionsBar = ({ player }: { player: HTMLVideoElement }) => {
  const playerGlobalState = UsePlayerProps((state) => state.playerState);
  const contentType = playerGlobalState.contentData?.content?.type;
  const [showStart, setShowStart] = useState(false);
  const [hasVast, setHasVast] = useState(false);

  useEffect(() => {
    const onPlaying = () => setShowStart(true);
    player.addEventListener('playing', onPlaying, { once: true });
    return () => player.removeEventListener('playing', onPlaying);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ActionBarContainer>
      {!hasVast && showStart && <WatchFromStart player={player} />}
      <ActionBarFlexWrapper justify='flex-start' align='center' ml={'auto'}>
        <AdCounter player={player} hasVast={(val) => setHasVast(val)} />
        {!hasVast && contentType && playerGlobalState.showingNextEpisode && contentType === 'episode' && playerGlobalState.contentConfigs?.next_episode &&
          <NextEpisodeButton player={player} />}
        {!hasVast && playerGlobalState.contentConfigs && <SkipIntro player={player} />}
      </ActionBarFlexWrapper>
    </ActionBarContainer>
  );
};

export default ActionsBar;
